<template>
  <div class="error-page">
    <ErrorScene
      code="403"
      description="抱歉！当前账号暂无访问权限，请联系管理员或切换账号后重试！"
      primary-text="重新登录"
      primary-icon="el-icon-switch-button"
      badge-text="受限"
      compact
      @primary="goLogin"
    />
  </div>
</template>

<script>
import { logout } from '@/api/api'
import { removeToken } from '@/utils/token'
import { resetRouter } from '@/router'
import ErrorScene from '@/components/error/ErrorScene'

export default {
  name: 'ForbiddenPage',
  components: {
    ErrorScene
  },
  methods: {
    resetSession() {
      this.$store.commit('user/setToken', '')
      this.$store.commit('user/setUser', '')
      this.$store.commit('menu/setMenus', [])
      this.$store.commit('menu/setRoutes', [])
      this.$store.commit('menu/setDisplayMenus', [])
      this.$store.commit('menu/setBtnMenus', [])
      this.$store.commit('menu/setActiveMenuArrary', [])
      this.$store.commit('menu/setActiveMenu', '/index')
      this.$store.commit('menu/setFlag', false)
      removeToken()
      resetRouter()
    },
    goLogin() {
      logout().catch(() => {}).finally(() => {
        this.resetSession()
        this.$router.replace('/login').catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at top, rgba(231, 238, 255, 0.94) 0, rgba(243, 246, 255, 0.98) 40%, #f7f9ff 100%);
}
</style>
